import React, { useEffect } from 'react';
import { SocialProofToast } from './components/SocialProofToast';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { OutcomesSection } from './components/OutcomesSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
interface AppProps {
  showSocialProof?: boolean;
}
export function App({
  showSocialProof = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '943022892065433');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="swgkxqawp4q6">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=943022892065433&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="36hzjfpzb85g" />
      </noscript>

      <div className="min-h-full w-full overflow-x-hidden bg-brand-cream" data-id="element-2" data-mp="d4xobc1ja5bs">
        <main data-id="element-3" data-mp="85l0op2u8u85">
          <Hero data-id="element-4" data-mp="851mnjgb6pze" />
          <PainSection data-id="element-5" data-mp="86mh792mi8x9" />
          <SolutionSection data-id="element-6" data-mp="86cnbaegjhma" />
          <ModulesSection data-id="element-7" data-mp="3gle7gc7darc0" />
          <BonusSection data-id="element-8" data-mp="3gkl9o0qdzc60" />
          <OutcomesSection data-id="element-9" data-mp="3gm65ruscn35z" />
          <PricingCard data-id="element-10" data-mp="3gja887keygi2" />
          <Guarantee data-id="element-11" data-mp="3bmjq7ep1tau0" />
          <Testimonials data-id="element-12" data-mp="3bn2zy84joswy" />
          <FAQ data-id="element-13" data-mp="3bnuwbl5yuuoa" />
          <FinalCTA data-id="element-14" data-mp="3bk70gfd1tw6e" />
        </main>
        <Footer data-id="element-15" data-mp="3qaxuzv60z9d7" />
        {showSocialProof && <SocialProofToast data-id="element-16" data-mp="3qbzcoihjqu3w" />}
      </div>
    </>;
}